import { Suspense } from 'react'
import { Provider } from 'react-redux'
import { PostHogProvider } from 'posthog-js/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { ErrorBoundary } from '@tino-frontend/adapters'
import { createTheme, ThemeInitializer } from '@tino-frontend/coreui'
import { DEFAULT_THEME } from '@tino-frontend/tokens'

import { StatsigProvider } from 'lib/statsig'
import { ServicesProvider } from 'services'
import { store } from 'stores'
import { withServiceWorker } from 'wrappers'
import { Alert } from 'modules/notification'
import { MockDebugContainer } from 'modules/mock-debug'

import {
  REACT_APP_ENV,
  REACT_APP_POSTHOG_HOST,
  REACT_APP_POSTHOG_KEY,
} from 'constants/envs'

import { Error } from 'layouts/Error'
import { PageLoader } from 'layouts/loaders'
import { Router } from 'pages/router'

const TEMP_DEFAULT_THEME = {
  ...DEFAULT_THEME,
  container: {
    values: {
      xs: 2,
      sm: 2,
      md: 2,
      lg: 2,
      xl: 2,
    },
  },
}

const createdDefaultTheme = createTheme(TEMP_DEFAULT_THEME as any)

function App() {
  const queryClient = new QueryClient()

  function handleLog(error: Error) {
    throw error
  }

  return (
    <PostHogProvider
      apiKey={REACT_APP_POSTHOG_KEY}
      options={{
        api_host: REACT_APP_POSTHOG_HOST,
        debug: REACT_APP_ENV === 'development',
      }}
    >
      <ThemeInitializer theme={createdDefaultTheme}>
        <ErrorBoundary fallback={<Error />} onLog={handleLog}>
          <Suspense fallback={<PageLoader />}>
            <ServicesProvider>
              <QueryClientProvider client={queryClient}>
                <Provider store={store}>
                  <StatsigProvider>
                    <Router />
                    <Alert />
                    <MockDebugContainer />
                  </StatsigProvider>
                </Provider>
                <ReactQueryDevtools initialIsOpen={false} />
              </QueryClientProvider>
            </ServicesProvider>
          </Suspense>
        </ErrorBoundary>
      </ThemeInitializer>
    </PostHogProvider>
  )
}

const component = withServiceWorker(App)

export default component
